/* global jQuery,location */
(function ($) {
  $(function () {
    var windowHeight = $(window).innerHeight()
    var headerHeight = $('#masthead').innerHeight()
    var affixheight = 0
    if ($('#menu-affix').is(':visible')) {
      affixheight = 54
    }
    function setHeight () {
      $('.full-h').css('min-height', windowHeight - headerHeight)
      $('.full-h-tot').css('min-height', windowHeight)
      $('.full-h-tot-menu').css('min-height', windowHeight - 30)
      $('.full-h-affix').css('min-height', windowHeight - headerHeight - affixheight)
      if ($('.auto-top').length) {
        $('.auto-top').css('top', $('#search').offset().top)
      }
    }
    setHeight()
    $(window).resize(function () {
      setHeight()
    })

    $('a.openmore').click(function (e) {
      e.preventDefault()
      $(this).siblings('.openmore-el').toggleClass('d-none', 'd-block')
    })

    $('a[href*="#"]').click(function () {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname) {
        var $target = $(this.hash)
        if (this.hash) {
          $target = $target.length && $target
          if ($target.length) {
            var targetOffset = $target.offset().top
            $('html,body').animate({scrollTop: targetOffset}, 1000)
            return false
          }
        }
      }
    })

      // Uno stupendo affix
    var tabaff = $('#tab-affix')

    var windowHeight = $(document).innerHeight()
    var headerHeight = $('#masthead').innerHeight()
    var pagetop = $(window).scrollTop()
    if (tabaff.length) {
      var hpageTit = $('.pgtt').innerHeight()
      var WrapperCollezioni = $('.affix-placeholder')
      var WrapperCollezioniTop = WrapperCollezioni.offset().top
      var WrapperCollezioniHeight = WrapperCollezioni.height()
      var AffixBottom = windowHeight - (WrapperCollezioniTop + WrapperCollezioniHeight)
      var AffixTop = tabaff.offset().top
      tabaff.affix({
        offset: {
          top: headerHeight + hpageTit - 20,
          bottom: AffixBottom
        }
      }
        )
    }
    tabaff.on('affixed.bs.affix', function () {
      $('.aflp').removeClass('hidden')
    }).on('affixed-top.bs.affix', function () {
      $('.aflp').addClass('hidden')
    }).on('affixed-bottom.bs.affix', function () {
      $('.aflp').addClass('hidden')
    })
    if (pagetop > 0) {
      $('.aflp').removeClass('hidden')
    }

        // Carousel Primopiano
       // Slider Homepage
    var $carousel = $('#primopiano')
    var $numeroItem = $carousel.find('.pp-it').length

    if ($numeroItem == '1' || $numeroItem == '2' || $numeroItem == '3') {
      var $numeroItemVisualizzatimd = $numeroItem
      var $numeroItemVisualizzatism = $numeroItem
      var $numeroItemVisualizzatilg = $numeroItem
    } else {
      var $numeroItemVisualizzatism = '2'
      var $numeroItemVisualizzatimd = '3'
      var $numeroItemVisualizzatilg = '3'
    };

    $carousel.owlCarousel({
      nav: false,
      dots: false,
      dotsEach: true,
      navContainer: '#primopiano-nav',
      navText: ['<span class="fa fa-chevron-left fa-lg blue pointer"></span>', '<span class="fa fa-chevron-right fa-lg blue pointer"></span>'],
      center:true,
      stagePadding: 0,
      autoWidth: true,
      loop: true,
      items: 3, // 10 items above 1000px browser width
      // onInitialized: manipulate,
      info: true,
      responsive: {
        0:{
          items:1,
          nav:false,
          dots:true,
          loop:true
        },
        768:{
          items: $numeroItemVisualizzatism,
          nav:false,
          dots:true,
          loop:true
        },
        1024:{
          items: $numeroItemVisualizzatimd,
          nav:false,
          dots:true,
          loop:true
        },
        1280:{
          items: $numeroItemVisualizzatilg,
          nav:false,
          dots:false,
          loop:true
        }
      }
    })

       // Galleria digitale
    var $carousel2 = $('#galleria-digitale')
    var $numeroItem = $carousel2.find('.gd-it').length

    if ($numeroItem == '1' || $numeroItem == '2' || $numeroItem == '3') {
      var $numeroItemVisualizzatimd = $numeroItem
      var $numeroItemVisualizzatism = $numeroItem
      var $numeroItemVisualizzatilg = $numeroItem
    } else {
      var $numeroItemVisualizzatism = '2'
      var $numeroItemVisualizzatimd = '3'
      var $numeroItemVisualizzatilg = '4'
    };

    $carousel2.owlCarousel({
      nav: false,
      dots: true,
      dotsEach: false,
      navContainer: '#galleria-digitale-nav',
      navText: ['<span class="fa fa-chevron-left fa-lg blue pointer"></span>', '<span class="fa fa-chevron-right fa-lg blue pointer"></span>'],
      stagePadding: 0,
      loop: true,
      items: 4, // 10 items above 1000px browser width
      // onInitialized: manipulate,
      info: true,
      responsive: {
        0:{
          items:2,
          nav:false,
          dots:true,
          loop:true
        },
        768:{
          items: $numeroItemVisualizzatism,
          nav:false,
          dots:true,
          loop:true
        },
        1024:{
          items: $numeroItemVisualizzatimd,
          nav:false,
          dots:true,
          loop:true
        },
        1280:{
          items: $numeroItemVisualizzatilg,
          nav:false,
          dots:true,
          loop:true
        }
      }
    })

    // Galleria digitale
    var $carousel3 = $('#approfondimenti')
    var $numeroItem = $carousel3.find('.ap-it').length

    if ($numeroItem == '1' || $numeroItem == '2') {
      var $numeroItemVisualizzatimd = $numeroItem
      var $numeroItemVisualizzatism = $numeroItem
      var $numeroItemVisualizzatilg = $numeroItem
    } else {
      var $numeroItemVisualizzatism = '2'
      var $numeroItemVisualizzatimd = '2'
      var $numeroItemVisualizzatilg = '2'
    };

    $carousel3.owlCarousel({
      nav: false,
      dots: true,
      dotsEach: false,
      navContainer: '#approfondimenti-nav',
      navText: ['<span class="fa fa-chevron-left fa-lg blue pointer"></span>', '<span class="fa fa-chevron-right fa-lg blue pointer"></span>'],
      stagePadding: 0,
      margin: 30,
      loop: true,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3000,
      items: 2, // 10 items above 1000px browser width
      // onInitialized: manipulate,
      info: true,
      responsive: {
        0:{
          items:1
        },
        768:{
          items: $numeroItemVisualizzatism
        },
        1024:{
          items: $numeroItemVisualizzatimd
        },
        1280:{
          items: $numeroItemVisualizzatilg
        }
      }
    })
    var $news = $('#news')
    $news.owlCarousel({
      nav: false,
      dotsEach: true,
      // navContainer: '#primopiano-nav',
      // navText: ['<span class="fa fa-chevron-left fa-lg blue pointer"></span>','<span class="fa fa-chevron-right fa-lg blue pointer"></span>'],
      loop: true,
      items: 1, // 10 items above 1000px browser width
      // onInitialized: manipulate,
      autoplay : true,
      autoplayHoverPause: true,
      info: true,
      responsive: {
        0:{
          items:1,
          nav:false,
          dots:true,
          loop:true
        },
        768:{
          items: 1,
          nav:false,
          dots:true,
          loop:false
        },
        1024:{
          items: 1,
          nav:false,
          dots:true,
          loop:true
        },
        1280:{
          items: 1,
          nav:false,
          dots:true,
          loop:true
        }
      }
    })
    let url = new URL(window.location.href)
    if (url.search === '' && url.hash === '') { window.sessionStorage.removeItem('search') }

    $('.btn-cerca').on('mouseover', function () {
      $(this).addClass('active')
    })
    $('.btn-cerca').on('click', function (event) {
      event.stopPropagation()
    })
    $('body').on('click', function (target) {
      if ($(this).attr('class') !== '.btn-cerca') {
        $('.btn-cerca').removeClass('active')
      }
    })
  })
})(jQuery)



// WEBPACK FOOTER //
// ./src/js/custom.js